export default {
  articles           : state => state.articles,
  articlesPage       : state => state.articlesPage,
  articlesPageLast   : state => state.articlesPageLast,
  articlesLoading    : state => state.articlesLoading,
  articlesSearch     : state => state.articlesSearch,
  articlesTop        : state => state.articlesTop,
  articlesTopLoading : state => state.articlesTopLoading,
  categories         : state => state.categories,
  categoriesCurrent  : state => state.categoriesCurrent,
  categoriesLoading  : state => state.categoriesLoading,
  specialistArticles : state => state.specialistArticles
}
